import Collection from 'lib/Collection';
import Device from 'entities/Device';

// @ts-expect-error ts-migrate(2305) FIXME: Module '"queries/__generated__/globalGQLTypes"' ha... Remove this comment to see the full error message
import type { SubscriptionMedium } from 'queries/__generated__/globalGQLTypes';

class Devices extends Collection<Device> {
  initialize() {
    // $FlowIssue
    this.url = '/devices';
    // @ts-expect-error ts-migrate(2740) FIXME: Type 'typeof Device' is missing the following prop... Remove this comment to see the full error message
    this.model = Device;
  }

  type(type: SubscriptionMedium): Device[] {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    return this.models.filter((model) => model.getType() === type);
  }

  enabled(): Device[] {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    return this.models.filter((model) => model.isEnabled());
  }
}

export default Devices;
